import React from "react";
import ReactECharts from "echarts-for-react";

const RateManagementBarChart: React.FC = () => {
  const categoryDistribution = [
    { category: "Residential", customerCount: 8542, revenue: 856000 },
    { category: "Commercial", customerCount: 1245, revenue: 524000 },
    { category: "Industrial", customerCount: 156, revenue: 685000 },
  ];

  const categories = categoryDistribution.map((item) => item.category);
  const customerCounts = categoryDistribution.map((item) => item.customerCount);
  const revenues = categoryDistribution.map((item) => item.revenue);

  const options = {
    xAxis: {
      type: "category",
      data: categories,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: [
      {
        type: "value",
        name: "Customer Count",
        position: "left",
        axisLabel: {
          formatter: "{value}",
          color: "#5F6368",
          fontSize: 9,
          fontWeight: 400,
          lineHeight: 11,
          letterSpacing: 0.2,
        },
      },
      {
        type: "value",
        name: "Revenue",
        position: "right",
        axisLabel: {
          formatter: "${value}",
          color: "#5F6368",
          fontSize: 9,
          fontWeight: 400,
          lineHeight: 11,
          letterSpacing: 0.2,
        },
      },
    ],
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      axisPointer: { type: "shadow" },
      formatter: (params: any) => {
        const [customer, revenue] = params;
        return `
          <div style="padding: 5px 10px; align-items:center; border-radius: 3px; color: #ffffff ;">
            <b>${customer.axisValue}</b><br/>
            Customer Count: ${customer.data}<br/>
            Revenue: $${revenue.data}
          </div>
        `;
      },
    },
    legend: {
      data: ["Customer Count", "Revenue"],
      textStyle: {
        fontSize: 10,
        color: "#4C5269",
      },
    },
    series: [
      {
        name: "Customer Count",
        data: customerCounts,
        type: "bar",
        yAxisIndex: 0,
        itemStyle: {
          color: "#1976d2",
        },
        barWidth: "30%",
      },
      {
        name: "Revenue",
        data: revenues,
        type: "bar",
        yAxisIndex: 1,
        itemStyle: {
          color: "#9CE976",
        },
        barWidth: "30%",
      },
    ],
    grid: {
      left: "3%",
      right: "3%",
      bottom: "3%",
      containLabel: true,
    },
  };

  return <ReactECharts option={options} style={{ height: "400px" }} />;
};

export default RateManagementBarChart;
